<template>
	<v-card
		elevation="0"
		v-if="reports && workbookReports"
		class="d-flex ma-0 pb-1"
		:color="itemColor"
	>
		<v-tooltip bottom>
			<template v-slot:activator="{ on, attrs }">
				<v-icon
					v-bind="attrs"
					v-on="on"
					class="draggable-handle me-3"
					style="cursor: grab"
					color="primary"
					small
					>mdi-reorder-horizontal</v-icon
				>
			</template>

			<span>Drag the handle ( </span>
			<span
				><v-icon
					small
					color="white"
					style="position: relative; top: 0; right: 0"
					>mdi-reorder-horizontal</v-icon
				></span
			>
			<span> ) to change the order of the report.</span>
		</v-tooltip>

		<v-autocomplete
			v-if="reportsFiltered"
			class="mr-5"
			label="Report"
			hide-details="auto"
			item-text="Name"
			item-value="Id"
			:items="reportsFiltered"
			v-model="item.ReportId"
			:rules="[isRequired]"
			@change="itemChanged()"
		></v-autocomplete>
		<v-text-field
			class="mx-5"
			label="Tab Name"
			hide-details="auto"
			v-model="item.TabName"
			:rules="[isRequired, max30Chars]"
			@change="itemChanged()"
		></v-text-field>
		<div style="display: flex; align-items: flex-end">
			<v-btn
				class="action-btn"
				fab
				small
				icon
				elevation="1"
				color="error"
				@click="removeReport()"
			>
				<v-icon small> mdi-delete</v-icon>
			</v-btn>
		</div>
	</v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import { WorkbookDetailsGetters } from '../../../../store/getters';
export default {
	name: 'WorkbookItem',
	props: { item: Object },
	computed: {
		...mapGetters({
			reports: [WorkbookDetailsGetters.REPORTS],
			workbookReports: [WorkbookDetailsGetters.WORKBOOK_REPORTS],
		}),
		reportsFiltered() {
			if (this.reports.length > 0) {
				let unusedReports = this.reports.filter(
					(x) =>
						!this.workbookReports
							.map((wr) => wr.ReportId)
							.includes(x.Id)
				);
				let selectedReport = null;
				if (this.item.ReportId) {
					selectedReport = this.reports.filter(
						(x) => x.Id == this.item.ReportId
					);
					unusedReports.push(selectedReport[0]);
				}
				return unusedReports;
			} else {
				return null;
			}
		},
		itemColor() {
			if (!this.item.WorkbookId) {
				return '#ffc00030';
			}
			return '#ffffff';
		},
	},
	data() {
		return {
			isRequired: (value) => !!value || 'Value is required',
			max30Chars: (value) =>
				(value && value.length <= 30) ||
				'Field must be 30 characters or less',
		};
	},
	methods: {
		removeReport() {
			ConfirmDialog({
				message: 'Are you sure you want to delete this report?',
			}).then((success) => {
				if (!success) return;
				this.$emit('removeReport');
			});
		},
		itemChanged() {
			this.$emit('workbookChanged');
		},
	},
};
</script>
